import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`text-xl md:text-2xl font-bold font-heading transition-colors duration-300 ${
              scrolled || !isHome ? 'text-primary-500' : 'text-white'
            }`}>
              飞飞漫画
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/80 hover:text-white'
              } ${location.pathname === '/' ? (scrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/80 hover:text-white'
              } ${location.pathname.startsWith('/category') ? (scrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/80 hover:text-white'
              } ${location.pathname === '/about' ? (scrolled || !isHome ? 'text-primary-500' : 'text-white') : ''}`}
            >
              关于我们
            </Link>
          </div>

          {/* Right actions */}
          <div className="flex items-center gap-3">
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-300 cursor-pointer ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/about"
              className={`hidden md:inline-flex whitespace-nowrap px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white text-foreground-950 hover:bg-white/90'
              }`}
            >
              登录
            </Link>

            {/* Mobile Hamburger */}
            <button
              className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer ${
                scrolled || !isHome
                  ? 'text-foreground-700'
                  : 'text-white'
              }`}
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-4 py-4 flex flex-col gap-3">
          <Link
            to="/"
            onClick={() => setMobileOpen(false)}
            className={`text-sm font-medium py-2 whitespace-nowrap ${location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700'}`}
          >
            首页
          </Link>
          <Link
            to="/category/all"
            onClick={() => setMobileOpen(false)}
            className={`text-sm font-medium py-2 whitespace-nowrap ${location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-700'}`}
          >
            分类
          </Link>
          <Link
            to="/about"
            onClick={() => setMobileOpen(false)}
            className={`text-sm font-medium py-2 whitespace-nowrap ${location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700'}`}
          >
            关于我们
          </Link>
        </div>
      )}
    </nav>
  );
}